import Home from './components/Home/Home'
import './App.css';


export default function App() {

  return (
    <Home />
  )
}